import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { uppercase, secondary } from 'scy/text/styles.mod.scss';
import { noUnderline } from 'scy/utils.mod.scss';
import { breadcrumbsFor } from 'shared/models/category';

function Breadcrumbs({ parentCategories, category, className }) {
  let breadcrumbs = [];
  if (parentCategories && parentCategories.length) {
    breadcrumbs = breadcrumbsFor(parentCategories);
  } else if (category) {
    breadcrumbs = breadcrumbsFor([category]);
  }

  return (
    <div className={classnames(uppercase, secondary, className)}>
      <Link to="/" className={noUnderline}>
        Saucey
      </Link>

      {!!breadcrumbs.length &&
        breadcrumbs.map(breadcrumb => (
          <span key={breadcrumb.url}>
            <span> / </span>
            <Link to={breadcrumb.url} className={noUnderline}>
              {breadcrumb.name}
            </Link>
          </span>
        ))}
    </div>
  );
}

export default Breadcrumbs;
export { breadcrumbsFor };
